export const APP_NAME = "demo";
export const ADMIN_ROLE = "admin";
export const ANY_ROLE = "any";
export const DEVELOPER_ROLE = 'developer';
export const HR_ROLE = 'hr';
